import React, { useEffect } from 'react';

import usePageTitle from '../../hooks/usePageTitle';
import ManageUserForm from './ManageUserForm';
import { usePageHeader } from '../../contexts/PageHeaderContext';
import { useAuth } from '../../AuthContext';

export function AddUser() {
    const { setPageHeader } = usePageHeader();
    const { currentUser } = useAuth();

    usePageTitle('Add User');

    useEffect(() => {
        setPageHeader('Add User');
        return () => setPageHeader(null);
    }, [setPageHeader]);

    // Block access if user's agency has payment out of date
    const isPaymentOutOfDate = currentUser?.belongs_to_agency?.payment_out_of_date === true;

    if (isPaymentOutOfDate) {
        const agencyName = currentUser?.belongs_to_agency?.name || 'your agency';
        return (
            <div className="container-fixed">
                <div className="card">
                    <div className="card-body">
                        <div className="flex flex-col items-center justify-center py-12 text-center">
                            <i className="ki-filled ki-information-circle text-6xl text-red-600 mb-4"></i>
                            <h3 className="text-2xl font-semibold text-gray-900 mb-2">
                                Feature Restricted
                            </h3>
                            <p className="text-gray-600 mb-4 max-w-md">
                                Adding new users is currently restricted because payment for {agencyName} is past due.
                            </p>
                            <p className="text-sm text-gray-500">
                                Please contact your agency administrator or SGB support to resolve this issue.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container-fixed">
            <ManageUserForm />
        </div>
    );
}